import { render, staticRenderFns } from "./youtube.vue?vue&type=template&id=5b692591&scoped=true"
import script from "./youtube.vue?vue&type=script&lang=js"
export * from "./youtube.vue?vue&type=script&lang=js"
import style0 from "./youtube.vue?vue&type=style&index=0&id=5b692591&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b692591",
  null
  
)

export default component.exports